if (!customElements.get("sticky-header")) {
  customElements.define(
    "sticky-header",
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.stickyDisabled = this.getAttribute("disabled") === "true";
        this.header = document.querySelector(".section-header");
        this.alwaysSticky = this.dataset.alwaysOn === "true";
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector("predictive-search");

        if (this.alwaysSticky) {
          this.header.classList.add("section-header-sticky-always");
        }

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => {
          this.preventReveal = true;
        };

        this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.addEventListener("scroll", this.onScrollHandler, false);

        this.createObserver();
      }

      disconnectedCallback() {
        this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.removeEventListener("scroll", this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.alwaysSticky) {
          // Hysteresis: collapse well past the header, restore only near the top.
          // A single threshold oscillates — collapsing shrinks the header, which
          // shifts the page and re-crosses the same threshold in reverse.
          if (scrollTop > 300) {
            this.header.classList.add("section-header-scrolled");
          } else if (scrollTop < 40) {
            this.header.classList.remove("section-header-scrolled");
          }
        }

        if (this.predictiveSearch && this.predictiveSearch.isOpen) {
          return;
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal && !this.stickyDisabled) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (!this.stickyDisabled && scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        } else if (this.stickyDisabled && scrollTop <= this.headerBounds.bottom) {
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.alwaysSticky) {
          return;
        }

        this.header.classList.add("section-header-hidden", "section-header-sticky");

        // Add methods to close dropdowns etc
        this.closeHeaderDropdowns();
      }

      reveal() {
        if (this.alwaysSticky) {
          return;
        }

        this.header.classList.add("section-header-sticky", "animate");
        this.header.classList.remove("section-header-hidden");
      }

      reset() {
        this.header.classList.remove("section-header-hidden", "section-header-sticky", "animate");
      }

      closeHeaderDropdowns() {
        const headerLocalizationDropdowns = this.header.querySelectorAll("localization-form");
        const headerDropdowns = this.header.querySelectorAll(".dropdown-modal");

        headerLocalizationDropdowns.forEach((dropdown) => {
          dropdown.hidePanel();
        });
        headerDropdowns.forEach((dropdown) => {
          dropdown.close();
        });
      }
    },
  );
}

// document.addEventListener("DOMContentLoaded", function() {
//   const angleIcons = document.querySelectorAll('.angle-icon');
//   angleIcons.forEach(function(icon) {
//     icon.addEventListener('click', function(event) {
//       event.preventDefault();
//       event.stopPropagation();

//       this.parentElement.classList.toggle('active');
//     });
//   });

//   const menuLinks = document.querySelectorAll('.menu-link');
//   menuLinks.forEach(function(link) {
//     link.addEventListener('click', function(event) {
//       const parentLi = this.closest('li.has-dropdown');

//       if (parentLi && event.target === this) {
//         if (window.innerWidth < 768) {
//           event.preventDefault();
//           parentLi.classList.toggle('active');
//         }
//       }
//     });
//   });
//   const collectionLinks = document.querySelectorAll('.menu-collection');
//   collectionLinks.forEach(function(link) {
//     link.addEventListener('click', function(event) {
//       event.stopPropagation();
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  // Sticky header hamburger menu
  const stickyMenu = document.querySelector(".head-slot-item-sticky-menu");
  if (stickyMenu) {
    const toggleBtn = stickyMenu.querySelector(".sticky-menu-toggle");
    toggleBtn.addEventListener("click", function (event) {
      event.stopPropagation();
      const isOpen = stickyMenu.classList.toggle("open");
      toggleBtn.setAttribute("aria-expanded", isOpen);
    });
    document.addEventListener("click", function (event) {
      if (!stickyMenu.contains(event.target)) {
        stickyMenu.classList.remove("open");
        toggleBtn.setAttribute("aria-expanded", "false");
      }
    });
  }

  // Menú de navegación principal (code existente)
  const angleIcons = document.querySelectorAll('.angle-icon');
  angleIcons.forEach(function (icon) {
    icon.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const parentLi = this.parentElement;
      parentLi.classList.toggle('active');

      // Mostrar u ocultar el submenu
      const submenu = parentLi.querySelector('.submenu');
      if (submenu) {
        if (parentLi.classList.contains('active')) {
          submenu.style.display = 'block';
        } else {
          submenu.style.display = 'none';
        }
      }
    });
  });

  const menuLinks = document.querySelectorAll('.menu-link');
  menuLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      const parentLi = this.closest('li.has-dropdown');

      if (parentLi && event.target === this) {
        if (window.innerWidth < 768) {
          event.preventDefault();
          parentLi.classList.toggle('active');

          // Mostrar u ocultar el submenu
          const submenu = parentLi.querySelector('.submenu');
          if (submenu) {
            if (parentLi.classList.contains('active')) {
              submenu.style.display = 'block';
            } else {
              submenu.style.display = 'none';
            }
          }
        }
      }
    });
  });

  // Manejo de submenús de segundo nivel
  const angleIconsLevel2 = document.querySelectorAll('.angle-icon-level2');
  angleIconsLevel2.forEach(function (icon) {
    icon.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const parentLi = this.parentElement;
      parentLi.classList.toggle('active');

      // Mostrar u ocultar el submenu de nivel 3
      const submenu = parentLi.querySelector('.submenu-level3');
      if (submenu) {
        if (parentLi.classList.contains('active')) {
          submenu.style.display = 'block';
        } else {
          submenu.style.display = 'none';
        }
      }
    });
  });

  // Manejo de clics en enlaces de colección (segundo nivel)
  const collectionLinks = document.querySelectorAll('.menu-collection');
  collectionLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      const parentLi = this.closest('li.has-dropdown-level2');

      if (parentLi && event.target === this) {
        if (window.innerWidth < 768) {
          event.preventDefault();
          parentLi.classList.toggle('active');

          // Mostrar u ocultar el submenu de nivel 3
          const submenu = parentLi.querySelector('.submenu-level3');
          if (submenu) {
            if (parentLi.classList.contains('active')) {
              submenu.style.display = 'block';
            } else {
              submenu.style.display = 'none';
            }
          }
        }
      } else {
        event.stopPropagation();
      }
    });
  });

});